import {SettingsAdminAuditLogDataEventObjectsEnum} from './settings/settingsAdminAuditLogDataEventObjects';
import {SettingsAdminCopilotDataEventObjectsEnum} from './settings/settingsAdminCopilotDataEventObjects';
import {SettingsAiDataEventObjectsEnum} from './settings/settingsAiDataEventObjects';
import {SettingsAppsDataEventObjectsEnum} from './settings/settingsAppsDataEventObjects';
import {SettingsChannelProactiveMessageDataEventObjectsEnum} from './settings/settingsChannelProactiveMessageDataEventObjects';
import {SettingsCirclesDataEventObjectsEnum} from './settings/settingsCirclesDataEventObjects';
import {SettingsCompanionDataEventObjectsEnum} from './settings/settingsCompanionDataEventObjects';
import {SettingsCompanyPreferencesDataEventObjectsEnum} from './settings/settingsCompanyPreferencesDataEventObjects';
import {SettingsCustomerPortalDataEventObjectsEnum} from './settings/settingsCustomerPortalDataEventObjects';
import {SettingsDynamicVariablesObjectsEnum} from './settings/settingsDynamicVariablesEventObjects';
import {SettingsExpressionsDataEventObjectsEnum} from './settings/settingsExpressionsDataEventObjects';
import {SettingsFlowchartRulesDataEventObjectsEnum} from './settings/settingsFlowchartRulesDataEventObjects';
import {SettingsInboxesDataEventObjectsEnum} from './settings/settingsInboxesDataEventObjects';
import {SettingsP1DataEventObjectsEnum} from './settings/settingsP1DataEventObjects';
import {SettingsPermissionsDataEventObjectsEnum} from './settings/settingsPermissions';
import {SettingsPlaybooksDataEventObjectsEnum} from './settings/settingsPlaybooksDataEventObjects';
import {SettingsResourceCopilotDataEventObjectsEnum} from './settings/settingsResourceCopilotDataEventObjects';
import {SettingsRulesDataEventObjectsEnum} from './settings/settingsRulesDataEventObjects';
import {SettingsSharedActionsDataEventObjectsEnum} from './settings/settingsSharedActionsDataEventObjects';
import {SettingsTeammatesDataEventObjectsEnum} from './settings/settingsTeammatesDataEventObjects';
import {SettingsTimeOffDataEventObjectsEnum} from './settings/settingsTimeOffDataEventObjects';
import {SettingsTopicsDataEventObjectsEnum} from './settings/settingsTopicsDataEventObjects';
import {SettingsWorkforceStaffingsDataEventObjectsEnum} from './settings/settingsWorkforceStaffingsDataEventObjects';

export enum CommonSettingsDataEventObjectsEnum {
  PAGE = 'page',
  ANNOTATION = 'annotation',
}

export const SettingsDataEventObjects = {
  ...CommonSettingsDataEventObjectsEnum,
  ...SettingsAiDataEventObjectsEnum,
  ...SettingsCirclesDataEventObjectsEnum,
  ...SettingsCompanionDataEventObjectsEnum,
  ...SettingsCompanyPreferencesDataEventObjectsEnum,
  ...SettingsRulesDataEventObjectsEnum,
  ...SettingsTeammatesDataEventObjectsEnum,
  ...SettingsDynamicVariablesObjectsEnum,
  ...SettingsCustomerPortalDataEventObjectsEnum,
  ...SettingsAdminAuditLogDataEventObjectsEnum,
  ...SettingsChannelProactiveMessageDataEventObjectsEnum,
  ...SettingsSharedActionsDataEventObjectsEnum,
  ...SettingsP1DataEventObjectsEnum,
  ...SettingsWorkforceStaffingsDataEventObjectsEnum,
  ...SettingsTopicsDataEventObjectsEnum,
  ...SettingsTimeOffDataEventObjectsEnum,
  ...SettingsExpressionsDataEventObjectsEnum,
  ...SettingsFlowchartRulesDataEventObjectsEnum,
  ...SettingsInboxesDataEventObjectsEnum,
  ...SettingsAdminCopilotDataEventObjectsEnum,
  ...SettingsPermissionsDataEventObjectsEnum,
  ...SettingsPlaybooksDataEventObjectsEnum,
  ...SettingsResourceCopilotDataEventObjectsEnum,
  ...SettingsAppsDataEventObjectsEnum,
};
